import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

import { Box, Text } from "../../../../../../mads";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import type { TagModel } from "../../../../viewjobOneGraphModel";
import { CompanySection } from "../InlineHeader/CompanySection";
import { LocationSection } from "../InlineHeader/LocationSection";
import { JobExpiredHeader } from "../JobExpiredHeader";
import { JobTitle } from "../JobTitle";
import { TagContainer } from "../TagContainer";

interface BasicJobInfoSectionProps {
  isExpired?: boolean;
  employerActivity?: string;
  tags?: TagModel[];
}

export function BasicJobInfoSection({
  isExpired = false,
  employerActivity,
  tags,
}: BasicJobInfoSectionProps) {
  const viewjobOneGraphModel = useViewjobOneGraphModel();

  if (!viewjobOneGraphModel) {
    return null;
  }

  return (
    <>
      {isExpired && <JobExpiredHeader />}

      {/* job title section */}
      <JobTitle jobTitle={viewjobOneGraphModel.job.jobTitle || ""} level={5} />

      {/* company name & rating section */}
      <CompanySection />

      {/* location section */}
      <LocationSection />

      <Box data-testid="jobsearch-OtherJobDetailsContainer">
        {employerActivity && (
          <Box sx={styles.employerActivity}>
            <Text sx={styles.employerActivityText}>{employerActivity}</Text>
          </Box>
        )}
        {tags != null && tags.length > 0 && <TagContainer tags={tags} />}
      </Box>
    </>
  );
}

const styles = StyleSheet.create({
  employerActivity: {
    marginTop: 8,
    marginBottom: 8,
    marginLeft: 16,
    paddingRight: 16,
  },
  locationContainer: {
    flexDirection: "row",
    gap: 8,
    alignItems: "center",
    left: -2,
    marginBottom: 6,
  },
  salaryContainer: {
    flexDirection: "row",
    alignItems: "baseline",
  },
  salaryNumbersText: {
    fontWeight: "500",
  },
  employerActivityText: {
    color: colors.neutral[700],
  },
});
